module.exports = __webpack_public_path__ + "img/package_filter.fa741392.jpg";